
import { createSsapInputId } from '../miscellaneous/createSsapInputId';

export const getValueFromSsapFormSnapshot = (snapshot, page, indexInArray, fields, name) => {
    const inputId = createSsapInputId(page, indexInArray, fields, name);

    const foundInput = snapshot.find(input => input.inputId === inputId);

    return foundInput ? foundInput.value : null;
};